export default [
  {
    "login": "nilaychauhan",
    "id": 44708711,
    "node_id": "MDQ6VXNlcjQ0NzA4NzEx",
    "avatar_url": "https://avatars2.githubusercontent.com/u/44708711?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/nilaychauhan",
    "html_url": "https://github.com/nilaychauhan",
    "followers_url": "https://api.github.com/users/nilaychauhan/followers",
    "following_url": "https://api.github.com/users/nilaychauhan/following{/other_user}",
    "gists_url": "https://api.github.com/users/nilaychauhan/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/nilaychauhan/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/nilaychauhan/subscriptions",
    "organizations_url": "https://api.github.com/users/nilaychauhan/orgs",
    "repos_url": "https://api.github.com/users/nilaychauhan/repos",
    "events_url": "https://api.github.com/users/nilaychauhan/events{/privacy}",
    "received_events_url": "https://api.github.com/users/nilaychauhan/received_events",
    "type": "User",
    "site_admin": false
  }
];